<template>
  <div>
    <div class="app-top">
      <top-title :dataList="topTitleList" :height="300"></top-title>
    </div>
    <div>
      <video-list />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import videoList from './components/videoList.vue'
import topTitle from '@/_myComponents/topTitle'

export default {
  components: { videoList, topTitle },
  name: 'video',
  data() {
    return {
      topTitleList: []
    }
  },
  watch: {},
  computed: {
    ...mapGetters(['softPrice'])
  },
  created() {
    this.utils.refreshSoftPrice(this.onloadArgs.getInvite())
    this.topTitleList = [
      {
        image: '',
        title: '视频教程',
        subTitle: '',
        backgroundImage: require('@/assets/images/bg/bg-5.jpg'),
        backgroundColor: `linear-gradient(rgba(${this.utils.hexToRgb(this.softPrice.softThemeColor)},0.5),rgba(${this.utils.hexToRgb(
          this.softPrice.softThemeColor
        )},0.1))`
      }
    ]
  },
  mounted() {},
  methods: {}
}
</script>
<style lang="scss" scoped>
.app-top {
  margin-top: 58px;
}
</style>